<template>
  <div class='page-layout-body' :class="{'fixed-page': !showFooter}">
    <HeatmapSwitch v-if="showHeatmap" />
    <top-header></top-header>
    <home-main></home-main>
    <Footer v-if="showFooter"/>
  </div>
</template>
<script>
// import { Layout } from 'ant-design-vue'
import TopHeader from "../home/common/top-header.vue";
import HomeMain from "../home/common/ad-main";
import Footer from '../home/common/footer'
import HeatmapSwitch from '../home/common/heatmap-switch.vue'

  export default {
    data() {
      return {
        collapsed: false,
      };
    },
    computed: {
      showFooter() {
        return this.$store.state.showFooter
      },
      showHeatmap() {
        return this.$store.state.showHeatmap
      }
    },
    components: {
      HomeMain,
      TopHeader,
      // Layout,
      Footer,
      HeatmapSwitch
    }
  };
</script>

<style lang="scss" scoped>
.fixed-page{
  display: flex;
  flex-direction: column;
}
</style>
